import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import { Tone } from '../../../../types.mjs';
import styles from './Combo.scss.mjs';
import { Footer } from './components/Footer/Footer.mjs';

const Combo = /*#__PURE__*/forwardRef(function Combo({
  className,
  children,
  focused,
  header,
  toolbar,
  footer,
  fullWidth = false,
  unframed,
  readOnly,
  hideFocusRing,
  style,
  onTransitionEnd,
  tone
}, ref) {
  const comboClassNames = classNames(styles.Combo, className, {
    [styles.focused]: focused && !hideFocusRing,
    [styles.withHeader]: header != null || toolbar != null,
    [styles.withFooter]: footer != null,
    [styles.readOnly]: readOnly
  });
  const toolbarMarkup = toolbar ? /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.ToolbarWrapper, unframed && styles.unframed, tone === Tone.Magic && styles.toneMagic)
  }, toolbar) : null;
  const footerMarkup = footer ? /*#__PURE__*/React__default.createElement(Footer, {
    tone: tone,
    unframed: unframed
  }, footer) : null;
  const slateMarkup = /*#__PURE__*/React__default.isValidElement(children) ? /*#__PURE__*/React__default.cloneElement(children, {
    className: classNames(styles.Slate, children.props.className, !toolbar && styles.compact, fullWidth && styles.fullWidth)
  }) : children;
  return /*#__PURE__*/React__default.createElement("section", {
    className: comboClassNames,
    style: style,
    onTransitionEnd: onTransitionEnd
  }, header, toolbarMarkup, /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: classNames(styles.Children, readOnly && styles.readOnly, unframed && styles.unframed, tone === Tone.Magic && styles.toneMagic)
    // Using negative tabIndex to avoid this element being focusable in Firefox
    ,
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.SlateWrapper, tone === Tone.Magic && styles.toneMagic)
  }, slateMarkup)), footerMarkup);
});

export { Combo };
